/* Additional Imports */
import FormAssetListController from './_form.AssetList.controller';
import FormDateRangeController from './_form.drop_DateRange.controller';

const reportParameterModule = angular
	.module('app.reportPara', ['ui.bootstrap', 'ui.router', 'gettext'])
	.controller('FormAssetListController', FormAssetListController)
	.controller('FormDateRangeController', FormDateRangeController);

export default reportParameterModule.name;
